export default __webpack_public_path__ + "static/media/search.ff04e160.svg";